import '@splidejs/splide/dist/css/splide.min.css';

import Splide from '@splidejs/splide';

const SummaryList = () => {
  const CONFIG_SPLIDE = {
    autoWidth: true,
    autoHeight: true,
    drag: false,
    arrows: false,
    pagination: false,
    breakpoints: {
      1024: {
        perPage: 1,
        pagination: false,
        gap: '1rem',
        drag: true
      }
    }
  };

  const summaryList = document.querySelector('.SummaryList');

  if (summaryList) {
    new Splide(`.SummaryList`, CONFIG_SPLIDE).mount();
  }
};

export default SummaryList;
